import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Clock } from "lucide-react";
import { BILLING } from "@/constants/testIds";
import { useWorkspace } from "@/context/WorkspaceContext";
import api from "@/lib/api";

export function TrialBanner() {
  const { active } = useWorkspace();
  const [info, setInfo] = useState(null);

  useEffect(() => {
    if (!active) return undefined;
    let alive = true;
    api
      .get("/billing", { params: { workspace_id: active.id } })
      .then(({ data }) => { if (alive) setInfo(data); })
      .catch(() => {});
    return () => { alive = false; };
  }, [active]);

  if (!info || info.stored_plan !== "pro_trial") return null;
  const urgent = info.days_left != null && info.days_left <= 4;

  return (
    <div
      data-testid={BILLING.trialBanner}
      className={`flex flex-wrap items-center justify-center gap-3 px-4 py-2 text-xs ${urgent ? "bg-amber-500/15 text-amber-300" : "bg-accent/10 text-accent"}`}
    >
      <Clock className="h-3.5 w-3.5" />
      <span>
        {urgent ? "Your Pro trial ends soon — add a card to keep Pro." : "You're on a 14-day Pro trial."}{" "}
        {info.days_left != null && <strong>{info.days_left} day{info.days_left === 1 ? "" : "s"} left.</strong>}
      </span>
      <Link
        to="/settings/billing"
        data-testid={BILLING.trialBannerUpgrade}
        className="rounded-full border border-current px-3 py-0.5 font-mono uppercase tracking-[0.14em] hover:opacity-80"
      >
        Upgrade
      </Link>
    </div>
  );
}
